<template>
  <b-container v-if="createAny('users')" fluid>

    <!-- Title bar -->
    <div class="title-bar">
      <h1>{{ $t("titles.resources") }}</h1>
      <div @click="edit_resource({ id: 0 })" class="btn btn-primary">
        <font-awesome-icon icon="plus" /> {{ $t("buttons.addresource") }}
      </div>
    </div>
    <!-- Table -->
    <b-table :items=resources :fields=fields @row-clicked="onresourceClicked">
      <template #cell(actions)="row">
        <div class="action-items">
          <a href="javascript:;" class="btn" @click="delete_a_resource(row.item.id)" :title="$t('labels.deleteresource')">
            <font-awesome-icon icon="trash" /> {{$t('labels.deleteresource')}}
          </a>
        </div>
      </template>
      <template #cell(type)="row">
        <div class="action-items">
          {{  resourceTypes.filter(rt => rt.id == row.item.type)[0].value }}
        </div>
      </template>
    </b-table>

  </b-container>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import resources_details_modal from './modals/ResourceModal'
import popup_modal from './modals/PopupModal.vue'

export default {
  name: 'resourcesscreen',
  data() {
    return {
      selectedID: null
    }
  },
  computed: {
    fields() {
      return [
      { key: 'name', label: this.$i18n.t('labels.name'), sortable: true, sortDirection: 'desc' },
      { key: 'type', label: this.$i18n.t('labels.resourcetype'), sortable: true, sortDirection: 'desc' },
      { key: 'identification', label: this.$i18n.t('labels.resourceidentification'), sortable: true, sortDirection: 'desc' },
      { key: 'actions'}
      ]
      
    },

    ...mapState([
      'resources',
    ]),
    ...mapGetters([
      'resource_by_id',
      'confirm_modal',
      'createAny'

    ]),
  },
  methods: {
    ...mapActions([
      'delete_resource',
      'save_resource'
    ]),
    delete_a_resource(id) {
      this.selectedID = id
      let message = this.$i18n.t('labels.confirmdeletehead') + this.resource_by_id(id).name + " - "+this.resource_by_id(id).identification + this.$i18n.t('labels.confirmdeletetail')
      this.$modal.hide('popup_modal')
      this.$modal.show(popup_modal, {
        message: message,
      }, {
        name: 'popup_modal',
        draggable: false,
        height: 'auto',
        width: '500px'
      }, {
        'before-close': this.modalClose
      })

      this.$emit('close')

    },
    modalClose() {
      if (this.confirm_modal.id == 1) {
        this.delete_resource(this.selectedID);
        for (let i = 0; i < this.resources.length; i++) {
          if (this.resources[i].id == this.selectedID) {
            this.resources.splice(i, 1);
          }
        }
      }
    },
    onresourceClicked(row) {
      this.$modal.hide('resources_details_modal')
      this.$modal.show(resources_details_modal, {
        resource_id: row.id,
      }, {
        name: 'resources_details_modal',
        draggable: '.popup-header',
        height: 'auto',
        width: '800px'
      })

      this.$emit('close')
    },
    edit_resource(resource) {
      this.$modal.hide('resources_details_modal')
      this.$modal.show(resources_details_modal, {
        resource_id: resource.id,
      }, {
        name: 'resources_details_modal',
        draggable: '.popup-header',
        height: 'auto',
        width: '800px'
      })

      this.$emit('close')
    },
  },
}
</script>